
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { FADE_IN_OUT_ANIMATION } from '@shared/animations';
import { User, Sort, Language, Role } from '@shared/data';
import { RoleQuery, UserQuery } from '@shared/queries';
import { LoadingService } from '@shared/modules/loading';

import { UserListDataTableOptions } from './user-list.data-table-options';

@Component({
  moduleId: 'module.id',
  selector: 'user-list',
  styles: [require('./user-list.component.scss')],
  template: require('./user-list.component.html'),
  animations: [FADE_IN_OUT_ANIMATION]
})
export class UserListComponent implements OnInit {
  public users: User[];
  public role: Role;
  public error: Parse.Error;
  public options: UserListDataTableOptions;

  constructor(private router: Router, private route: ActivatedRoute, private loadingService: LoadingService) {
    this.options = new UserListDataTableOptions();
  }

  // ===============================================================================================
  // Override Methods
  // ===============================================================================================

  public ngOnInit(): void {
    this.fetchUsers();
  }

  // ===============================================================================================
  // Actions
  // ===============================================================================================

  public onDelete(row: number): void {
    let user = this.users[row];

    Parse.Cloud.run('deleteUser', { objectId: user.id }).then(
      result => {
        this.fetchUsers();
      },
      error => {
        this.error = error;
      }
    );
  }

  public onRowSelect(row: number) {
    this.router.navigate(['edit', this.users[row].id], {
      relativeTo: this.route
    });
  }

  // ===============================================================================================
  // Private Methods
  // ===============================================================================================

  private fetchUsers(): void {
    if (this.users && !this.users.length) {
      this.options.pagination.page = 1;
    }

    let query = new RoleQuery().notEqualTo(Role.NAME_KEY, Role.USER_ROLE);

    this.users = [];
    this.loadingService.continue();

    query.find().then(
      result => {
        result.forEach(role => {
          let userQuery = role.users.query();

          userQuery.find().then(
            (users: User[]) => {
              users.forEach(u => {
                u['role'] = role.displayedName;
              });

              this.users = this.users.concat(users);
              this.loadingService.complete();
            },
            error => {
              this.error = error;
              this.loadingService.complete();
            }
          );
        });
      },
      error => {
        this.error = error;
        this.loadingService.complete();
      }
    )
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+user/user-list/user-list.component.ts